<form [formGroup]="contractAgreementForm">
    <div
        class="lg:flex items-start !mt-2 bg-palette-base-white rounded-lg border  general-information-ota-section mx-auto pointer-events-none">
        <div class="!p-6 lg:!w-[31.55%] flex items-center !gap-3">
            <div>
                <p class="font-inter !text-lg !font-semibold text-palette-gray-900">
                    {{ "OTA.CONTRACT_AGREEMENT.USER_INFORMATION" | translate }}
                </p>
                <p class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1">
                    {{ "OTA.CONTRACT_AGREEMENT.VERIFICATION" | translate }}
                </p>
            </div>
        </div>
        <div class="!p-6 max-lg:!pt-0 lg:!w-[68.45%] disabled-approve">
            <div>
                <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{
                    "OTA.CONTRACT_AGREEMENT.FULL_NAME" | translate }}
                </p>
                <input
                    class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1 input-contracts-agreement is-disable"
                    formControlName="fullName" [placeholder]="'OTA.CONTRACT_AGREEMENT.P_FULL_NAME' | translate"
                    type="text">
            </div>
            <div class="!mt-4">
                <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.EMAIL"
                    | translate }} </p>
                <input
                    class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1 input-contracts-agreement is-disable"
                    formControlName="email" [placeholder]="'OTA.CONTRACT_AGREEMENT.P_EMAIL' | translate"
                    type="text">
            </div>
            <div class="!mt-4 disabled-approve phone-input-disabled">
                <label for="phoneNumber" class="font-inter !mb-1 !text-sm !font-medium text-palette-gray-700">{{
                    "OTA.CONTRACT_AGREEMENT.PHONE_NUMBER" | translate }}</label>
                <app-input-phone-number #phoneNumberRef [id]="'phoneNumber'" [phone]="phoneNumber">
                </app-input-phone-number>
            </div>
            <!-- IDENTITY_NUMBER -->
            <div class="!mt-4">
                <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.IDENTITY_NUMBER" | translate }} 
                </p>
                <input
                    class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1 input-contracts-agreement is-disable"
                    formControlName="identityNumber"
                    [placeholder]="'OTA.CONTRACT_AGREEMENT.IDENTITY_NUMBER_PLACEHOLDER' | translate"
                    type="text">
            </div>
            <!-- ISSUE_DATE/EXPIRY_DATE -->
            <div class="flex !gap-4 calendar-issue-date">
                <div class="!mt-4 w-1/2 calendar-issue-date calendar-promotions calendar-filter-to">
                    <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.ISSUE_DATE" | translate }} 
                    </p>
                    <span class="p-input-icon-right flex items-center">
                        <i class="pi sctr-icon-calendar text-[20px] z-10 !m-0"></i>
                        <p-calendar
                            class="w-full !h-[44px] rounded-md !min-h-[44px] text-[14px] p-calendar flex items-center is-disable" 
                            formControlName="issueDate"
                            dateFormat="dd/mm/yy"
                            placeholder="dd/mm/yyyy" 
                            [firstDayOfWeek]="1">
                        </p-calendar>
                    </span>
                    
                </div>
                <div class="!mt-4 w-1/2 calendar-issue-date calendar-promotions calendar-filter-to">
                    <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.EXPIRY_DATE" | translate }} 
                    </p>
                    <span class="p-input-icon-right flex items-center">
                        <i class="pi sctr-icon-calendar text-[20px] z-10 !m-0"></i>
                        <p-calendar
                            class="w-full !h-[44px] rounded-md !min-h-[44px] text-[14px] p-calendar is-disable" 
                            formControlName="expiredDate"
                            dateFormat="dd/mm/yy"
                            placeholder="dd/mm/yyyy" 
                            [firstDayOfWeek]="1">
                        </p-calendar>
                    </span>
                    
                </div>
            </div>
        </div>
    </div>
    <!-- CONTRACT -->
    <div class="lg:flex bg-white rounded-lg border border-palette-gray-200 general-information-ota-section !mt-3">
        <div class="lg:!w-[31.55%] !p-6">
            <p class="font-inter text-lg font-semibold text-palette-gray-900">{{
                "OTA.CONTRACT_AGREEMENT.CONTRACT_AGREEMENT" | translate }}</p>
            <p class="font-inter text-sm font-normal text-palette-gray-700 !mt-1">{{ "OTA.CONTRACT_AGREEMENT.INFO" |
                translate }}</p>
        </div>
        <div class="lg:!w-[68.45%] !p-6 max-lg:!pt-0">
            <div>
                <!-- Select a role -->
                <div class="!mt-4 pointer-events-none">
                    <p class="font-inter !text-sm !font-medium text-palette-gray-700">
                        {{ "OTA.CONTRACT_AGREEMENT.ROLE" | translate }} 
                    </p>
                    <div class="xl:!flex max-xl:!flex-none max-xl:space-y-4 !gap-4 !mt-2">
                        <div *ngFor="let rule of rules"
                            class="border !h-[56px] rounded-lg xl:!w-[50%] flex justify-between !py-3 !px-4 items-center hover:bg-palette-gray-100"
                            [class.active-rule]="rule === selectedRuleModel" 
                            [ngClass]="{'disable-check': f['selectedRule'].disabled, 
                            'cursor-pointer': f['selectedRule'].enabled, 
                            'opacity-50': f['selectedRule'].disabled && rule === selectedRuleModel}">
                            <div class="flex justify-start !gap-3 items-center">
                                <i [ngClass]="addClassActiveRule(rule, selectedRuleModel)"
                                    class="!text-xl !leading-[20px] text-palette-gray-500">
                                </i>
                                <p [ngClass]="{ '!text-palette-blue-600': rule === selectedRuleModel }"
                                    class="font-inter !text-sm !font-medium text-palette-gray-700">
                                    {{ rule.name | translate }}
                                </p>
                            </div>
                            <div>
                                <p-radioButton [(ngModel)]="selectedRuleModel" [inputId]="rule.key"
                                    formControlName="selectedRule" [value]="rule">
                                </p-radioButton>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="this.contractAgreementForm.value.selectedRule" class="flex flex-col !gap-4 !mt-2">
                    <!-- Property name -->
                    <div class="pointer-events-none">
                        <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.PROPERTY_NAME" | translate }} 
                        </p>
                        <input
                            class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1 input-contracts-agreement is-disable"
                            [ngClass]="{'form-disable': f['propertyName'].disabled}"
                            formControlName="propertyName"
                            [placeholder]="'OTA.CONTRACT_AGREEMENT.ENTER_PROPERTY_NAME' | translate"
                            type="text">
                    </div>
                    <!-- legal entity name -->
                    <div class="pointer-events-none">
                        <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.LEGAL_NAME" | translate }} 
                        </p>
                        <input
                            class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1 input-contracts-agreement is-disable"
                            [ngClass]="{'form-disable': f['legalName'].disabled}"
                            formControlName="legalName"
                            [placeholder]="'OTA.CONTRACT_AGREEMENT.ENTER_LEGAL_NAME' | translate"
                            type="text">
                    </div>
                    <!-- Upload file -->
                    <div class="flex flex-col !gap-2 w-full">
                        <p class="font-inter !text-sm !font-medium text-palette-gray-700">
                            <ng-container *ngIf="this.contractAgreementForm.value.selectedRule.key === '0'; else personal">
                                {{ "OTA.CONTRACT_AGREEMENT.BUSINESS_LICENSE" | translate }}
                            </ng-container>
                            <ng-template #personal>
                                {{ "OTA.CONTRACT_AGREEMENT.OTHER_FILE" | translate }} 
                            </ng-template>
                        </p>
                        <ng-container *ngIf="draggedFiles.length > 0;">
                            <div *ngFor="let item of draggedFiles; let idx = index"
                                class="w-full !p-4 flex !gap-3 border border-palette-gray-200 rounded-lg">
                                <div class="flex items-center justify-center h-10 !w-10 !min-w-10 rounded-full bg-palette-gray-50">
                                    <div class="flex items-center justify-center h-8 !w-8 rounded-full bg-palette-gray-100">
                                        <i class="sctr-icon-file-05 text-palette-gray-500 text-[16px]"></i>
                                    </div>
                                </div>
                                <div class="flex justify-between items-start w-full">
                                    <div [ngClass]="{'pointer-events-none': contractAgreementForm.disabled}">
                                        <p class="text-sm font-medium text-palette-gray-900">{{item.file.name}}</p>
                                        <p *ngIf="item.file.size > 0" class="text-sm font-normal text-palette-gray-500">{{item.file.size}} KB</p>
                                        <div class="flex items-center !mt-1 !gap-1">
                                            <i class="sctr-icon-check-circle text-palette-green-600 text-[16px]"></i>
                                            <p class="text-sm font-medium text-palette-green-600">
                                                {{'OTA.CONTRACT_AGREEMENT.UPLOAD_SUCCESS' | translate}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="ml-2 mt-1 cursor-pointer">
                                        <i class="sctr-icon-download-01 text-palette-blue-600 text-[20px]" (click)="downloadAllFiles(item)"></i>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <!-- TAX_NUMBER -->
                    <ng-container *ngIf="selectedRuleModel.key === '0'">
                        <div class="pointer-events-none">
                            <p class="font-inter !text-sm !font-medium text-palette-gray-700">{{ "OTA.CONTRACT_AGREEMENT.TAX_NUMBER" | translate }} 
                            </p>
                            <input
                                class="font-inter !text-sm !font-normal text-palette-gray-700 !mt-1 input-contracts-agreement is-disable"
                                [ngClass]="{'form-disable': f['taxNumber'].disabled}"
                                formControlName="taxNumber"
                                [placeholder]="'OTA.CONTRACT_AGREEMENT.TAX_NUMBER_PLACEHOLDER' | translate"
                                type="text">
                        </div>
                    </ng-container>
                    <div class="flex flex-col !gap-1 w-full pointer-events-none">
                        <p class="font-inter !text-sm !font-medium text-palette-gray-700">
                            {{'OTA.CONTRACT_AGREEMENT.DESCRIPTION' | translate}}
                        </p>
                        <textarea 
                          formControlName="description"
                          class="disable-description description-css !w-full !h-[144px] !text-sm leading-5 border border-palette-gray-300 text-palette-gray-600 font-inter !py-3 !px-3 !font-normal !rounded-lg outline-none form-input"
                          placeholder="{{'OTA.CONTRACT_AGREEMENT.ENTER_DESCRIPTION' | translate}}"
                          pInputTextarea
                          [autoResize]="false"></textarea>
                    </div>
                </div>
                <!-- Checkbox -->
                <div class="flex !mt-4 !gap-2 pointer-events-none">
                    <p-checkbox [value]="true" formControlName="checkboxAgree">
                    </p-checkbox>
                    <p class="text-sm font-medium text-palette-gray-700">{{
                        'OTA.CONTRACT_AGREEMENT.AUTHORIZED_CONTRACT' | translate }}</p>
                </div>
            </div>
        </div>
    </div>
</form>